import * as React from 'react';
import SvgIcon, {SvgIconProps} from '@material-ui/core/SvgIcon';

/**
 * @deprecated Please use 'mdi-material-ui/<icon-name>'
 * @param props
 * @constructor
 */
const CustomSvgIconTS: React.FunctionComponent<SvgIconProps & {path: string}> = props => {
  const {path, ...other} = props;
  return (
    <SvgIcon {...other}>
      <path d={path} />
    </SvgIcon>
  );
};

CustomSvgIconTS['muiName'] = SvgIcon['muiName'];
export default CustomSvgIconTS;
